import 'svelte/internal/disclose-version';

Drop[$.FILENAME] = 'src/web/concepts/drop.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations($.from_html(`<li class="flex justify-between border-b border-ink/30 py-1"><span> </span><span class="opacity-60 tabular-nums"> </span></li>`), Drop[$.FILENAME], [[31, 26, [[31, 87], [31, 108]]]]);

var root_1 = $.add_locations(
	$.from_html(
		`
      <ul class="flex flex-col gap-1">
        <!>
      </ul>
      <button class="btn self-start">We'll study it. Pick a time.</button>
    `,
		1
	),
	Drop[$.FILENAME],
	[[30, 6], [33, 6]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">Show us how you work today.</h1>
    <button type="button">
      <span class="font-display text-2xl font-semibold">Drop anything here</span>
      <span class="opacity-60">That messy spreadsheet, a screenshot, a paper form photo, a PDF</span>
    </button>
    <input type="file" multiple="" class="hidden"/>
    <!>
  `,
		1
	),
	Drop[$.FILENAME],
	[[17, 4], [18, 4, [[25, 6], [26, 6]]], [28, 4]]
);

var root_3 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight"> </h1>
    <!>
  `,
		1
	),
	Drop[$.FILENAME],
	[[36, 4]]
);

var root_4 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-3xl flex flex-col gap-8">
  <!>
</div>`,
		1
	),
	Drop[$.FILENAME],
	[[15, 0]]
);

function Drop($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Drop);

	let files = $.tag_proxy($.proxy([]), 'files');
	let over = $.tag($.state(false), 'over');
	let ready = $.tag($.state(false), 'ready');
	let picker;

	const add = (list) => {
		if (list) files.push(...Array.from(list));
	};

	const size = (n) => n > 1e6
		? `${(n / 1e6).toFixed(1)} MB`
		: `${Math.max(1, Math.round(n / 1e3))} KB`;

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_4();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = root_2();
			var button = $.sibling($.first_child(fragment_1), 3);
			var input = $.sibling(button, 2);

			$.bind_this(input, ($$value) => picker = $$value, () => picker);

			var node_1 = $.sibling(input, 2);

			{
				var consequent = ($$anchor) => {
					var fragment_2 = root_1();
					var ul = $.sibling($.first_child(fragment_2));
					var node_2 = $.sibling($.child(ul));

					$.add_svelte_meta(
						() => $.each(node_2, 17, () => files, $.index, ($$anchor, f) => {
							var li = root();
							var span = $.child(li);
							var text = $.only_child(span, true);
							var span_1 = $.sibling(span);
							var text_1 = $.only_child(span_1, true);

							$.reset(li);

							$.template_effect(
								($0) => {
									$.set_text(text, $.get(f).name);
									$.set_text(text_1, $0);
								},
								[() => size($.get(f).size)]
							);

							$.append($$anchor, li);
						}),
						'each',
						Drop,
						31,
						8
					);

					$.next();
					$.reset(ul);

					var button_1 = $.sibling(ul, 2);

					$.next();

					$.delegated('click', button_1, function click_1() {
						return $.set(ready, true);
					});

					$.append($$anchor, fragment_2);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (files.length) $$render(consequent);
					}),
					'if',
					Drop,
					29,
					4
				);
			}

			$.next();

			$.template_effect(() => $.set_class(button, 1, $.clsx([
				"flex flex-col items-center justify-center gap-2 h-64 border-2 border-dashed border-ink text-lg transition-colors",
				$.get(over) && "bg-ink text-accent"
			])));

			$.event('dragover', button, function dragover(e) {
				e.preventDefault();
				$.set(over, true);
			});

			$.event('dragleave', button, function dragleave() {
				return $.set(over, false);
			});

			$.event('drop', button, function drop(e) {
				e.preventDefault();
				$.set(over, false);
				add(e.dataTransfer?.files ?? null);
			});

			$.delegated('click', button, function click() {
				return picker.click();
			});

			$.delegated('change', input, function change(e) {
				return add(e.currentTarget.files);
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_3 = root_3();
			var h1 = $.sibling($.first_child(fragment_3));
			var text_2 = $.only_child(h1);
			var node_3 = $.sibling(h1, 2);

			{
				let $0 = $.derived(() => files.map((f) => f.name).join(", "));

				$.add_svelte_meta(
					() => Booking(node_3, {
						get summary() {
							return $.get($0);
						}
					}),
					'component',
					Drop,
					37,
					4,
					{ componentTag: 'Booking' }
				);
			}

			$.next();
			$.template_effect(() => $.set_text(text_2, `We'll come to the call having studied your ${$.strict_equals(files.length, 1) ? "file" : `${files.length} files`}.`));
			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(ready)) $$render(consequent_1); else $$render(alternate, -1);
			}),
			'if',
			Drop,
			16,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Drop = $.hmr(Drop);

	import.meta.hot.accept((module) => {
		Drop[$.HMR].update(module.default);
	});
}

export default Drop;

$.delegate(['click', 'change']);